export function replaceInvalidCharacters(input) {
    if (input == null) return "";

    const str = String(input);

    return Array.from(str)
        .map((c) => {
            switch (c) {
                case "\u06f0": return "0";
                case "\u06f1": return "1";
                case "\u06f2": return "2";
                case "\u06f3": return "3";
                case "\u06f4": return "4";
                case "\u06f5": return "5";
                case "\u06f6": return "6";
                case "\u06f7": return "7";
                case "\u06f8": return "8";
                case "\u06f9": return "9";

                case "ی": return "ي";
                case "ى": return "ي";

                case "ك": return "ک";

                default: return c;
            }
        })
        .join("");
}

export function normalizePersianSearch(value: unknown): string {
    if (value == null) return "";

    return String(value).normalize("NFKC").replace(/[يى]/g, "ی").replace(/ك/g, "ک").replace(/[أإٱ]/g, "ا")
        .replace(/[۰-۹]/g, char =>
            String("۰۱۲۳۴۵۶۷۸۹".indexOf(char))
        )
        .replace(/[٠-٩]/g, char =>
            String("٠١٢٣٤٥٦٧٨٩".indexOf(char))
        )

        .replace(/[\u064B-\u065F\u0670]/g, "").replace(/\u0640/g, "")
        .replace(/[\s\u200C\u200D]+/g, "").trim().toLowerCase();
}
